import { type GetProps, useInteractiveElement, webPointerProps, XStack } from "@medbillai/ui";
type PressableStackProps = Omit<GetProps<typeof XStack>, "onPress"> & {
  onPress: () => void;
  disabled?: boolean;
};

/** A stack that acts as a button, with keyboard focus on web. */
export function PressableStack({
  onPress,
  disabled,
  ...rest
}: PressableStackProps) {
  const {
    interactiveProps
  } = useInteractiveElement({
    onPress,
    disabled
  });
  return <XStack role="button" pressStyle={{
    scale: 0.97
  }} transition="press" {...webPointerProps} {...rest} {...interactiveProps} data-sentry-element="XStack" data-sentry-component="PressableStack" data-sentry-source-file="PressableStack.tsx" />;
}